export function getFI(f, i, email) {
  if (f && i) {
    return (
      String(f)
        .charAt(0)
        .toUpperCase() +
      String(i)
        .charAt(0)
        .toUpperCase()
    );
  } else {
    return String(email)
      .charAt(0)
      .toUpperCase();
  }
}
